import React from 'react'
import Navbar from '../../@shared/navigations/default'
import {  onlineUsers } from './mock'
import { UsersList } from './users'
import { OnlineItem } from './online'

const UsersPage = () => {
    const [count] = React.useState(0)
    const [onlines]  = React.useState(onlineUsers)

    return (
        <div className="container6">
            <title>Users</title>
            <Navbar />
            {count>0 && <h2 className="mt-3">{count} online</h2>}
            <div  className="users_list">
                <ul>
                    { onlines.map((item,i)=>(
                        <OnlineItem key={'online-user'+i} user={item} />
                    ))}
                </ul>
            </div>
            <UsersList />
        </div>
    )
}

export default UsersPage




